export interface TimezoneOption {
  value: string;
  label: string;
  region: string;
  offset: string;
}

export const timezoneOptions: TimezoneOption[] = [
  // UTC
  { value: "UTC", label: "UTC (Coordinated Universal Time)", region: "UTC", offset: "UTC+0" },
  
  // Europe
  { value: "Europe/London", label: "London (GMT/BST)", region: "Europe", offset: "UTC+0/+1" },
  { value: "Europe/Paris", label: "Paris (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Berlin", label: "Berlin (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Rome", label: "Rome (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Madrid", label: "Madrid (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Amsterdam", label: "Amsterdam (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Brussels", label: "Brussels (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Vienna", label: "Vienna (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Zurich", label: "Zurich (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Stockholm", label: "Stockholm (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Oslo", label: "Oslo (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Copenhagen", label: "Copenhagen (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Helsinki", label: "Helsinki (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Riga", label: "Riga (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Tallinn", label: "Tallinn (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Vilnius", label: "Vilnius (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Warsaw", label: "Warsaw (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Prague", label: "Prague (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Budapest", label: "Budapest (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Bratislava", label: "Bratislava (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Ljubljana", label: "Ljubljana (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Zagreb", label: "Zagreb (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Belgrade", label: "Belgrade (CET/CEST)", region: "Europe", offset: "UTC+1/+2" },
  { value: "Europe/Sofia", label: "Sofia (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Bucharest", label: "Bucharest (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Athens", label: "Athens (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Istanbul", label: "Istanbul (TRT)", region: "Europe", offset: "UTC+3" },
  { value: "Europe/Kiev", label: "Kiev (EET/EEST)", region: "Europe", offset: "UTC+2/+3" },
  { value: "Europe/Minsk", label: "Minsk (MSK)", region: "Europe", offset: "UTC+3" },
  { value: "Europe/Moscow", label: "Moscow (MSK)", region: "Europe", offset: "UTC+3" },
  { value: "Europe/Dublin", label: "Dublin (GMT/IST)", region: "Europe", offset: "UTC+0/+1" },
  { value: "Europe/Lisbon", label: "Lisbon (WET/WEST)", region: "Europe", offset: "UTC+0/+1" },
  { value: "Europe/Reykjavik", label: "Reykjavik (GMT)", region: "Europe", offset: "UTC+0" },

  // North America
  { value: "America/New_York", label: "New York (EST/EDT)", region: "North America", offset: "UTC-5/-4" },
  { value: "America/Chicago", label: "Chicago (CST/CDT)", region: "North America", offset: "UTC-6/-5" },
  { value: "America/Denver", label: "Denver (MST/MDT)", region: "North America", offset: "UTC-7/-6" },
  { value: "America/Los_Angeles", label: "Los Angeles (PST/PDT)", region: "North America", offset: "UTC-8/-7" },
  { value: "America/Anchorage", label: "Anchorage (AKST/AKDT)", region: "North America", offset: "UTC-9/-8" },
  { value: "America/Honolulu", label: "Honolulu (HST)", region: "North America", offset: "UTC-10" },
  { value: "America/Toronto", label: "Toronto (EST/EDT)", region: "North America", offset: "UTC-5/-4" },
  { value: "America/Vancouver", label: "Vancouver (PST/PDT)", region: "North America", offset: "UTC-8/-7" },
  { value: "America/Mexico_City", label: "Mexico City (CST/CDT)", region: "North America", offset: "UTC-6/-5" },
  { value: "America/Phoenix", label: "Phoenix (MST)", region: "North America", offset: "UTC-7" },

  // South America
  { value: "America/Sao_Paulo", label: "São Paulo (BRT/BRST)", region: "South America", offset: "UTC-3/-2" },
  { value: "America/Buenos_Aires", label: "Buenos Aires (ART)", region: "South America", offset: "UTC-3" },
  { value: "America/Santiago", label: "Santiago (CLT/CLST)", region: "South America", offset: "UTC-3/-2" },
  { value: "America/Bogota", label: "Bogota (COT)", region: "South America", offset: "UTC-5" },
  { value: "America/Lima", label: "Lima (PET)", region: "South America", offset: "UTC-5" },
  { value: "America/Caracas", label: "Caracas (VET)", region: "South America", offset: "UTC-4" },

  // Asia
  { value: "Asia/Tokyo", label: "Tokyo (JST)", region: "Asia", offset: "UTC+9" },
  { value: "Asia/Shanghai", label: "Shanghai (CST)", region: "Asia", offset: "UTC+8" },
  { value: "Asia/Hong_Kong", label: "Hong Kong (HKT)", region: "Asia", offset: "UTC+8" },
  { value: "Asia/Singapore", label: "Singapore (SGT)", region: "Asia", offset: "UTC+8" },
  { value: "Asia/Seoul", label: "Seoul (KST)", region: "Asia", offset: "UTC+9" },
  { value: "Asia/Manila", label: "Manila (PHT)", region: "Asia", offset: "UTC+8" },
  { value: "Asia/Bangkok", label: "Bangkok (ICT)", region: "Asia", offset: "UTC+7" },
  { value: "Asia/Ho_Chi_Minh", label: "Ho Chi Minh (ICT)", region: "Asia", offset: "UTC+7" },
  { value: "Asia/Jakarta", label: "Jakarta (WIB)", region: "Asia", offset: "UTC+7" },
  { value: "Asia/Kuala_Lumpur", label: "Kuala Lumpur (MYT)", region: "Asia", offset: "UTC+8" },
  { value: "Asia/Phnom_Penh", label: "Phnom Penh (ICT)", region: "Asia", offset: "UTC+7" },
  { value: "Asia/Vientiane", label: "Vientiane (ICT)", region: "Asia", offset: "UTC+7" },
  { value: "Asia/Yangon", label: "Yangon (MMT)", region: "Asia", offset: "UTC+6:30" },
  { value: "Asia/Dhaka", label: "Dhaka (BST)", region: "Asia", offset: "UTC+6" },
  { value: "Asia/Kolkata", label: "Kolkata (IST)", region: "Asia", offset: "UTC+5:30" },
  { value: "Asia/Kathmandu", label: "Kathmandu (NPT)", region: "Asia", offset: "UTC+5:45" },
  { value: "Asia/Colombo", label: "Colombo (SLST)", region: "Asia", offset: "UTC+5:30" },
  { value: "Asia/Karachi", label: "Karachi (PKT)", region: "Asia", offset: "UTC+5" },
  { value: "Asia/Tashkent", label: "Tashkent (UZT)", region: "Asia", offset: "UTC+5" },
  { value: "Asia/Almaty", label: "Almaty (ALMT)", region: "Asia", offset: "UTC+6" },
  { value: "Asia/Bishkek", label: "Bishkek (KGT)", region: "Asia", offset: "UTC+6" },
  { value: "Asia/Dushanbe", label: "Dushanbe (TJT)", region: "Asia", offset: "UTC+5" },
  { value: "Asia/Ashgabat", label: "Ashgabat (TMT)", region: "Asia", offset: "UTC+5" },
  { value: "Asia/Tehran", label: "Tehran (IRST)", region: "Asia", offset: "UTC+3:30" },
  { value: "Asia/Baghdad", label: "Baghdad (AST)", region: "Asia", offset: "UTC+3" },
  { value: "Asia/Kuwait", label: "Kuwait (AST)", region: "Asia", offset: "UTC+3" },
  { value: "Asia/Riyadh", label: "Riyadh (AST)", region: "Asia", offset: "UTC+3" },
  { value: "Asia/Dubai", label: "Dubai (GST)", region: "Asia", offset: "UTC+4" },
  { value: "Asia/Muscat", label: "Muscat (GST)", region: "Asia", offset: "UTC+4" },
  { value: "Asia/Baku", label: "Baku (AZT)", region: "Asia", offset: "UTC+4" },
  { value: "Asia/Tbilisi", label: "Tbilisi (GET)", region: "Asia", offset: "UTC+4" },
  { value: "Asia/Yerevan", label: "Yerevan (AMT)", region: "Asia", offset: "UTC+4" },

  // Africa
  { value: "Africa/Cairo", label: "Cairo (EET/EEST)", region: "Africa", offset: "UTC+2/+3" },
  { value: "Africa/Lagos", label: "Lagos (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Johannesburg", label: "Johannesburg (SAST)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Nairobi", label: "Nairobi (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Addis_Ababa", label: "Addis Ababa (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Dar_es_Salaam", label: "Dar es Salaam (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Kampala", label: "Kampala (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Khartoum", label: "Khartoum (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Tripoli", label: "Tripoli (EET)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Algiers", label: "Algiers (CET)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Casablanca", label: "Casablanca (WET)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Tunis", label: "Tunis (CET)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Accra", label: "Accra (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Dakar", label: "Dakar (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Bamako", label: "Bamako (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Conakry", label: "Conakry (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Freetown", label: "Freetown (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Monrovia", label: "Monrovia (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Banjul", label: "Banjul (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Bissau", label: "Bissau (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Nouakchott", label: "Nouakchott (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Ouagadougou", label: "Ouagadougou (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Abidjan", label: "Abidjan (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Lome", label: "Lome (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Porto-Novo", label: "Porto-Novo (GMT)", region: "Africa", offset: "UTC+0" },
  { value: "Africa/Niamey", label: "Niamey (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Kinshasa", label: "Kinshasa (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Brazzaville", label: "Brazzaville (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Luanda", label: "Luanda (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Libreville", label: "Libreville (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Malabo", label: "Malabo (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Douala", label: "Douala (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Yaounde", label: "Yaounde (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Bangui", label: "Bangui (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Ndjamena", label: "Ndjamena (WAT)", region: "Africa", offset: "UTC+1" },
  { value: "Africa/Bujumbura", label: "Bujumbura (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Gitega", label: "Gitega (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Kigali", label: "Kigali (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Bujumbura", label: "Bujumbura (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Lubumbashi", label: "Lubumbashi (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Harare", label: "Harare (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Lusaka", label: "Lusaka (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Maputo", label: "Maputo (CAT)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Antananarivo", label: "Antananarivo (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Mogadishu", label: "Mogadishu (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Djibouti", label: "Djibouti (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Asmara", label: "Asmara (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Juba", label: "Juba (EAT)", region: "Africa", offset: "UTC+3" },
  { value: "Africa/Windhoek", label: "Windhoek (WAT/WAST)", region: "Africa", offset: "UTC+1/+2" },
  { value: "Africa/Maseru", label: "Maseru (SAST)", region: "Africa", offset: "UTC+2" },
  { value: "Africa/Mbabane", label: "Mbabane (SAST)", region: "Africa", offset: "UTC+2" },

  // Oceania
  { value: "Pacific/Auckland", label: "Auckland (NZST/NZDT)", region: "Oceania", offset: "UTC+12/+13" },
  { value: "Pacific/Sydney", label: "Sydney (AEST/AEDT)", region: "Oceania", offset: "UTC+10/+11" },
  { value: "Pacific/Melbourne", label: "Melbourne (AEST/AEDT)", region: "Oceania", offset: "UTC+10/+11" },
  { value: "Pacific/Brisbane", label: "Brisbane (AEST)", region: "Oceania", offset: "UTC+10" },
  { value: "Pacific/Perth", label: "Perth (AWST)", region: "Oceania", offset: "UTC+8" },
  { value: "Pacific/Adelaide", label: "Adelaide (ACST/ACDT)", region: "Oceania", offset: "UTC+9:30/+10:30" },
  { value: "Pacific/Darwin", label: "Darwin (ACST)", region: "Oceania", offset: "UTC+9:30" },
  { value: "Pacific/Hobart", label: "Hobart (AEST/AEDT)", region: "Oceania", offset: "UTC+10/+11" },
  { value: "Pacific/Fiji", label: "Fiji (FJT)", region: "Oceania", offset: "UTC+12" },
  { value: "Pacific/Guam", label: "Guam (ChST)", region: "Oceania", offset: "UTC+10" },
  { value: "Pacific/Port_Moresby", label: "Port Moresby (PGT)", region: "Oceania", offset: "UTC+10" },
  { value: "Pacific/Honiara", label: "Honiara (SBT)", region: "Oceania", offset: "UTC+11" },
  { value: "Pacific/Noumea", label: "Noumea (NCT)", region: "Oceania", offset: "UTC+11" },
  { value: "Pacific/Palau", label: "Palau (PWT)", region: "Oceania", offset: "UTC+9" },
  { value: "Pacific/Pohnpei", label: "Pohnpei (PONT)", region: "Oceania", offset: "UTC+11" },
  { value: "Pacific/Tarawa", label: "Tarawa (GILT)", region: "Oceania", offset: "UTC+12" },
  { value: "Pacific/Tongatapu", label: "Tongatapu (TOT)", region: "Oceania", offset: "UTC+13" },
  { value: "Pacific/Funafuti", label: "Funafuti (TVT)", region: "Oceania", offset: "UTC+12" },
  { value: "Pacific/Apia", label: "Apia (WST)", region: "Oceania", offset: "UTC+13" },
  { value: "Pacific/Kiritimati", label: "Kiritimati (LINT)", region: "Oceania", offset: "UTC+14" }
];

export const getTimezoneByValue = (value: string): TimezoneOption | undefined => {
  return timezoneOptions.find(tz => tz.value === value);
};

export const getTimezonesByRegion = (region: string): TimezoneOption[] => {
  return timezoneOptions.filter(tz => tz.region === region);
};

export const getTimezoneRegions = (): string[] => {
  const regions = new Set(timezoneOptions.map(tz => tz.region));
  return Array.from(regions);
};

export const getLocationOptions = () => {
  const regions = getTimezoneRegions();
  const options = [
    { value: "all", label: "All Locations" },
    ...regions.map(region => ({
      value: region.toLowerCase(),
      label: region,
    })),
  ];
  return options;
};

// Static mapping for timezone values to readable names
export const getTimezoneNameByValue = (value: string): string => {
  const timezone = timezoneOptions.find(tz => tz.value === value);
  return timezone ? timezone.label : value;
};

// Get timezones by region for filtering
export const getTimezonesByRegionForFilter = (region: string) => {
  if (region === "all") return [];
  const timezones = getTimezonesByRegion(region);
  return timezones.map(tz => ({
    value: tz.value,
    label: tz.label,
  }));
};

// Get all timezones for the comprehensive filter dropdown
export const getAllTimezonesForFilter = () => {
  const allTimezones = timezoneOptions.map(tz => tz.value); // Use timezoneOptions directly
  
  // Group by region for better organization
  const groupedTimezones: { [region: string]: { value: string; label: string }[] } = {};
  
  allTimezones.forEach(tz => {
    let region = 'Other';
    if (tz.startsWith('America/')) region = 'North America';
    else if (tz.startsWith('Europe/')) region = 'Europe';
    else if (tz.startsWith('Asia/')) region = 'Asia';
    else if (tz.startsWith('Africa/')) region = 'Africa';
    else if (tz.startsWith('Pacific/') || tz.startsWith('Australia/')) region = 'Oceania';
    else if (tz.startsWith('Atlantic/')) region = 'Atlantic';
    else if (tz.startsWith('Indian/')) region = 'Indian Ocean';
    else if (tz === 'UTC') region = 'UTC';
    
    if (!groupedTimezones[region]) {
      groupedTimezones[region] = [];
    }
    
    const city = tz.split('/').pop()?.replace(/_/g, ' ') || tz;
    let offset = '';
    try {
      const date = new Date();
      const utc = date.getTime() + (date.getTimezoneOffset() * 60000);
      const targetTime = new Date(utc + (0 * 60000));
      const targetOffset = targetTime.toLocaleString('en-US', { timeZone: tz, timeZoneName: 'short' });
      offset = targetOffset.split(' ').pop() || '';
    } catch (error) {
      // Ignore offset errors
    }
    
    const label = `${city} ${offset ? `(${offset})` : ''}`.trim();
    
    groupedTimezones[region].push({
      value: tz,
      label
    });
  });
  
  // Convert to flat array with region separators
  const result: { value: string; label: string; isSeparator?: boolean }[] = [];
  
  Object.entries(groupedTimezones).forEach(([region, timezones]) => {
    // Add region separator
    result.push({
      value: `---${region}---`,
      label: `--- ${region} ---`,
      isSeparator: true
    });
    
    // Add timezones for this region
    result.push(...timezones.sort((a, b) => a.label.localeCompare(b.label)));
  });
  
  return result;
};

// Get timezone options for the User Growth Trends filter
export const getTimezoneOptionsForUserGrowth = () => {
  const allTimezones = getAllTimezonesForFilter();
  
  // Filter out separator items and duplicates, then sort alphabetically
  const filteredTimezones = allTimezones
    .filter(option => !option.isSeparator)
    .filter((option, index, self) => 
      index === self.findIndex(t => t.value === option.value)
    )
    .sort((a, b) => a.label.localeCompare(b.label));
  
  // Create base options and sort them alphabetically
  const baseOptions = [
    { value: "ALL", label: "All Timezones" },
    { value: "local", label: "Local Time (User's Browser Timezone)" },
    { value: "UTC", label: "UTC (Coordinated Universal Time)" }
  ].sort((a, b) => a.label.localeCompare(b.label));
  
  return [
    ...baseOptions,
    ...filteredTimezones
  ];
};
